<section class="evidencias" style="margin-top: 10vh;">

  <div class="container">

    <!-- HEADER -->
    <div class="section-header">
      <h2>Evidencias</h2>
      <p>Sube documentos e imágenes</p>
    </div>

    <!-- CARD -->
    <div class="upload-card">

      <form [formGroup]="documentoForm">

        <label class="upload-label">
          Selecciona archivos
        </label>

        <input
          type="file"
          (change)="contarArchivos($event)"
          multiple
        >

        <!-- ESTADO -->
        <div class="upload-status">

          <!-- CARGANDO -->
          <div *ngIf="subiendoDocumento" class="spinner"></div>

          <!-- OK -->
          <div *ngIf="!subiendoDocumento && urlDocumento">
            <i class="bi bi-check-circle-fill success-icon"></i>
            <span>Archivo subido</span>
          </div>

        </div>

      </form>

    </div>

  </div>

</section>
